import { HttpClient, HttpMethods } from "@planzone/services";

function createDocument(httpClient: HttpClient) {
  return (
    name: string,
    template: string,
    folder: string,
    namespace: string,
    type: string,
  ) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/api/documents/create`,
      method: HttpMethods.POST,
      data: {
        name,
        template,
        folder,
        namespace,
        type,
      },
    });
}

export { createDocument };
